/* @flow */

import * as React from 'react';
import {Link} from 'react-router-dom';

import {CompanyContactIcon, AccountIcon, ExternalLinkIcon} from '../../../icon';
import {TwoLine} from '../../../two-line';
import {Stack} from '../../../layout';
import {RelativeTimestamp} from '../../../timestamp';

import './company-header.css';

export type CompanyHeaderDetails = {|
    name: string,
    timestamp: number,
    htmlUrlPath?: string,
|};

type Props = {|
    ...CompanyHeaderDetails,
|};

export function CompanyHeader(props: Props) {
    let Icon,
        iconStyleName,
        iconSize = 28,
        companyName = props.name,
        timestampText;

    if (props.htmlUrlPath) {
        Icon = AccountIcon;
        iconStyleName = 'company-icon-container--added';
        iconSize = 24;
        companyName = (
            <Link to={props.htmlUrlPath}>
                <Stack spacing={8} isHorizontal={true} alignCenter={true} newTab={true}>
                    {props.name}
                    <ExternalLinkIcon size={13} wrapWithDiv={false} />
                </Stack>
            </Link>
        );
        timestampText = 'Added';
    } else {
        Icon = CompanyContactIcon;
        iconStyleName = 'company-icon-container--visitor';
        timestampText = 'Seen';
    }

    return (
        <TwoLine
            topRow={<div styleName='company-name'>{companyName}</div>}
            bottomRow={
                <div styleName='company-timestamp'>
                    <div>{timestampText}&nbsp;</div>
                    <RelativeTimestamp datetime={props.timestamp} />
                </div>
            }
            avatar={
                <div styleName={iconStyleName}>
                    <Icon size={iconSize} wrapWithDiv={false} />
                </div>
            }
        />
    );
}
